'use strict';

var sign = require('./bn-sign');

module.exports = bn2num; //TODO: Make this better

function bn2num(b) {
  var l = b.length;
  var words = b.words;
  var out = 0;

  if (l === 1) {
    out = words[0];
  } else if (l === 2) {
    out = words[0] + words[1] * 0x4000000;
  } else {
    for (var i = 0; i < l; i++) {
      var w = words[i];
      out += w * Math.pow(0x4000000, i);
    }
  }

  return sign(b) * out;
}